import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import { AGENT_SITE, PROFILES, STORAGE } from "../../constants";
import { AuthService } from "../../services/AuthService";
import { LocalStorageService } from "../../services/LocalStorageService";
import { useTranslation } from 'react-i18next';
import { ConfigurationService } from "../../services/ConfigurationService";
import SelectLanguage from "../../components/SelectLanguage";
import { UsersService } from "../../services/UsersService";
import { SupportService } from "../../services/SupportService";


declare const HSCore: any;
declare const FB: any;
declare const window: any;
declare const loadFBSDK: any;

function EmbeddedSignup() {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors, isValid, isSubmitting  } } = useForm({
        mode: 'onChange',
        defaultValues: {
            user_name: '',
            password: ''
        },
    });

    const [errorMessage, seterrorMessage] = useState('')

    const getAccounts = async(id) => {
        const allData = {
            user_id: id
        }
        const { data } = await ConfigurationService.getAllAccounts(allData);
        LocalStorageService.save(STORAGE.ACCOUNTS_ASSIGNED, data)

        return data;
    }
    
    const getLinksSupport = async() => {
        const { data } = await SupportService.getAll();
        LocalStorageService.save(STORAGE.SUPPORT_DATA, data)

        return data;
    }

    
    const handlePermissions = async(user_id: number, account_id: number, profile: string) => {

        if(profile.toLowerCase() === PROFILES.ROOT || profile.toLowerCase() === PROFILES.ADMIN) {
            return LocalStorageService.save(STORAGE.PERMISSIONS, { 
                full_access: true
            });
        }
        
        if(profile.toLowerCase() === PROFILES.SUPERVISOR ) {

            const { data } = await UsersService.getCurrentPermissions({
                account_id,
                user_id
            })
            return LocalStorageService.save(STORAGE.PERMISSIONS, data);
        }

    }

    const launchWhatsAppSignup = () => {
      // Conversion tracking code
      // fbq && fbq('trackCustom', 'WhatsAppOnboardingStart', { 
      //   appId: '702435971362183', 
      //   feature: 'whatsapp_embedded_signup'
      // });
      
      // Launch Facebook login
      FB.login( (response) => {
        console.log("🚀 ~ response:", response)
        if (response.authResponse) {
          const code = response.authResponse.code;
          // The returned code must be transmitted to your backend, 
        // which will perform a server-to-server call from there to our servers for an access token
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }


        FB.getLoginStatus(function(response) {
            console.log(response);
        });
      }, {
        config_id: '2162595040745152', // configuration ID goes here
        response_type: 'code',    // must be set to 'code' for System User access token
        override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
        extras: {
            "sessionInfoVersion": 2,
        }
      });
    }

    useEffect(() => {
        document.body.className = '';

        try {
            HSCore.components.HSTomSelect.init('.js-select')
        } catch (error) { }


        loadFBSDK()

        window.fbAsyncInit = function () {
          // JavaScript SDK configuration and setup
          FB.init({
            appId:    '702435971362183', // Facebook App ID
            cookie:   true, // enable cookies
            xfbml:    true, // parse social plugins on this page
            version:  'v19.0' //Graph API version
          });
        };

        return () => {
            document.body.className = 'has-navbar-vertical-aside navbar-vertical-aside-show-xl footer-offset';
        };
    }, [])


    return (
        <div className="d-flex align-items-center min-h-100">
            <main id="content" role="main" className="main pt-0">

                <div className="container-fluid px-0">

                    <div className="row mx-0">

                        <div className="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100 position-relative">

                            <div className="position-absolute top-0 start-0 end-0 d-lg-flex mt-3 mx-3">
                                <SelectLanguage />
                            </div>
                            <div className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1" style={{ maxWidth: '25rem' }} >

                                <div>
                                    <div className="text-center">
                                        <div className="d-grid">
                                            <img className=" mb-5 logo-auth" src="/assets/img/logo.png" alt="Description" />
                                        </div>

                                        <div className="mb-5">
                                            <h1 className="display-5 text-start">Registro integrado para WhatsApp Business</h1>
                                            <p className="text-start">Registrate en unos solos pasos para integrar el API de WhatsApp Business con nuestra plataforma.</p>
                                        </div>
                                    </div>

                                    

                                    <div className="my-4">
                                      <button onClick={launchWhatsAppSignup} className="btn-fb">Login with Facebook</button>
                                    </div>



                                    <div className="my-4">
                                        <label className="form-check-label d-grid">
                                            {t("auth.login.help")}
                                        </label>
                                        <a href="https://api.whatsapp.com/send?phone=5524156393&text=Hola, buen día, necesito de su apoyo" target="_blank" >
                                            <img className="mb-2 mt-1 logo-cw" src="/assets/img/whatsapp.png" alt="Description" /> Whatsapp
                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a href="mailto:ayuda@voices.com.mx" >
                                            <img className="mb-2 mt-1 logo-cm" src="/assets/img/mail.png" alt="Description" />  {t("auth.login.mail")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center min-vh-lg-100 position-relative bg-light px-0"  >
                            <img src='/assets/img/bg-bot.png' className="img-fluid" />
                        </div>


                        
                    </div>
                </div>
            </main >

            
        </div >
    );
}

export default EmbeddedSignup;